import packageJson from '../../../../package.json';

export const environment = {
  production: true,
  apiUrl: location.origin + '/api',
  version: packageJson.version,
  showBuildInfo: true,
  staging: true,
  stripePublishableKey: 'pk_test_51R8jDyBAlnZMf6HHzyWF4LRceFVTraSc1syd1CBHrWoKQydNHmwXMOY8vhJuz8rSXeefhlvrNjJoUx7DZx7tZfho005LsyPwXj'
};
